export const types = {
  SET_VENDORS: "SET_VENDORS",
  CREATE_VENDOR: "CREATE_VENDOR",
  UPDATE_VENDOR: "UPDATE_VENDOR",
  DELETE_VENDOR: "DELETE_VENDOR",
};
